import MessageComposerSavedReplies from './MessageComposerSavedReplies';

export default MessageComposerSavedReplies;
